






























import {  Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class UiCopyTextarea extends mixins(PlanLimitsMixin) {
  copyTooltipShow: boolean = false;

  @Prop() 
  label: string;

  @Prop() 
  copyButtonLabel: string;
  
  @Prop() 
  rows: number;
  
  @Prop() 
  value: string;
  
  @Prop() 
  labelHelp: string;

  
  handleCopyScript() {
    // @ts-ignore
    let input = this.$refs.textareaRef.$el.querySelector('textarea');
    input.select();
    document.execCommand('copy');
    this.copyTooltipShow = true;
    setTimeout(() => {
      this.copyTooltipShow = false;
    }, 2000);
  }
}
